import { filter, ignoreElements, tap } from 'rxjs/operators';

import { RootEpic } from '../../../store/epics';
import { loadAnalyticsDataSuccess } from '../reducers/analytics-data';

const updateRUMUserIdEpic: RootEpic = (action$, state$, { api: { datadog } }) =>
  action$.pipe(
    filter(loadAnalyticsDataSuccess.match),
    tap(({ payload: { userId } }) => {
      datadog.setDDUser({
        id: userId,
        email: state$.value.preliminaryInfo.info.email,
        applicantId: state$.value.session.applicantId ?? undefined,
      });
    }),
    ignoreElements(),
  );

export const datadogRUMEpic = updateRUMUserIdEpic;
